import { FC } from 'react';
import { CellContainer, Text } from '@/_components';
import { CellYearProps } from './CellYear.types';

export const CellYear: FC<CellYearProps> = ({ year }) => {
  return (
    <CellContainer width={40}>
      <Text type="tiny">{year}</Text>
    </CellContainer>
  );
};
